var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "qr-quota font-light"
  }, [_vm.currentPlan ? _c('div', {
    staticClass: "font-weight-medium"
  }, [_c('span', {
    staticClass: "activated"
  }, [_vm._v(" " + _vm._s(_vm.formatNumber(_vm.usedCodesCount)) + " " + _vm._s(_vm.$t('used')) + " ")]), _vm._v(" / "), _c('span', [_vm._v(" " + _vm._s(_vm.formatNumber(_vm.totalCodesCount)) + " " + _vm._s(_vm.$t('total')) + " ")])]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }